<template>
  <div class="catalog">
    <div class="container">
      <div class="catalog__container">
        <div class="catalog__header">
          <div class="catalog__header-left">
            <button @click="router.go(-1)" class="catalog__back">
              <svg width="8" height="12">
                <use xlink:href="@/assets/icons/sprite.svg#arrowLeft"></use>
              </svg>
            </button>
            <h1>{{ section.name }}</h1>
          </div>
          <RouterLink to="/search">
            <svg width="36" height="36">
              <use xlink:href="@/assets/icons/sprite.svg#searchBtn"></use>
            </svg>
          </RouterLink>
        </div>
        <div class="catalog__categories" v-if="false">
          <div class="catalog__categories-icon">
            <svg width="28" height="28">
              <use :xlink:href="iconPath"></use>
            </svg>
          </div>
          <div class="catalog__categories-content">
            <div class="catalog__categories-title">Молоко, сыры,яйцо</div>
            <div class="catalog__categories-text">523 товара</div>
          </div>
        </div>
        <Tags
          v-if="sectionDetail.length > 0"
          class="catalog__tags"
          :data="sectionDetail"
        />
        <div v-if="isLoading" class="loader">
          <div class="loader-spinner"></div>
        </div>
        <div v-else>
          <div class="catalog__list">
            <Card v-for="item in items" :data="item" />
          </div>
          <div>
            <Pagination :source="pagination" @show-more="showMore" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <CartModal />
</template>
<script setup lang="ts">
  import router from "@/router";
  import { computed, ref, watch } from "vue";
  import sprite from "@/assets/icons/sprite.svg";
  import Tags from "@/components/Tags.vue";
  import Card from "@/components/Card.vue";
  import CartModal from "@/components/CartModal.vue";
  import { IPagination, IProduct, ISection, ISectionsItem } from "@/models/models";
  import Pagination from "@/components/Pagination.vue";

  const props = defineProps(["data"]);

  const iconPath = computed(() => `${sprite}#saus`);

  const items = ref<Array<IProduct>>([] as Array<IProduct>);

  const section = ref<ISection>({} as ISection);

  const sectionDetail = ref<Array<ISectionsItem>>([] as Array<ISectionsItem>);

  const pagination = ref<IPagination>({} as IPagination);

  const isLoading = ref(false);

  let isShowMore: boolean = false;

  const getData = () => {
    if (!isShowMore) {
      isLoading.value = true;
    }

    fetch(
      `https://akshop.a-dev.xyz/api/v1/catalog/products?sectionId=${
        router.currentRoute.value.params.name
      }&${new URLSearchParams(
        router.currentRoute.value.query as Record<string, string>
      )}`
    )
      .then((response) => response.json())
      .then((data) => {
        section.value = data.section;
        pagination.value = data.pagination;

        if (isShowMore) {
          items.value = [...data.items, ...items.value];
          isShowMore = false;
        } else {
          items.value = data.items;
        }

        return data;
      })
      .then((data) => {
        fetch(`https://akshop.a-dev.xyz/api/v1/sections/${data.section.id}`)
          .then((response) => response.json())
          .then((data) => {
            sectionDetail.value = data.sections;
            isLoading.value = false;
          });
      });
  };

  const showMore = (page: number) => {
    isShowMore = true;
    router.push({
      path: router.currentRoute.value.path,
      params: router.currentRoute.value.params,
      query: { ...router.currentRoute.value.query, ...{ page: page } },
    });
  };

  getData();

  watch(
    () => router.currentRoute.value,
    async (newVal, oldVal) => {
      if ((oldVal && newVal.path == oldVal.path) || oldVal == undefined) {
        getData();
      }
    },
    {
      deep: true,
      immediate: false,
    }
  );
</script>
<style lang="scss">
  .catalog {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: $almostBlack;
    padding-bottom: 12px;

    &__categories {
      display: flex;
      gap: 12px;
      margin-bottom: 12px;

      &-content {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      &-title {
        font-size: 16px;
        line-height: 22px;
        font-weight: 700;
        color: $almostBlack;
      }

      &-text {
        font-size: 14px;
        line-height: 16px;
        font-weight: 400;
        color: $darkGray;
      }

      &-icon {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        width: 44px;
        height: 44px;
        background-color: $lightGreen;
      }
    }

    &__header {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 32px;
      margin-top: 12px;
      min-height: 36px;
      gap: 10px;

      &-left {
        display: flex;
        align-items: center;
        gap: 12px;
      }
    }

    &__list {
      margin-top: 20px;
      margin-bottom: 12px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
    }
  }
</style>
